module.exports = __webpack_public_path__ + "static/media/Smartpub Terms of Service.60bce514.pdf";